import moment from "moment";

/*
  
  A template is the data structure for a time series chart:
  
  e.g.
  const template = [
    {
      field: "instance_cost",
      title: "Instance cost",
      color: blue[500],
      data: [...]
    },
    {
      field: "license_cost",
      title: "License cost",
      color: orange[500],
      data: [...]
    }
  ];
*/
export const generateTimeSeries = (template, records, accumulate) => {
  return template.map(series => {
    const { color, title, field } = series;
    let val = 0;
    const data = [];
    records.forEach(el => {
      val = accumulate ? val + el[field] : el[field];
      data.push({ x: el.timestamp, y: val });
    });

    return { color, title, disabled: false, data };
  });
};

export const isLessThanADay = granularity => {
  const { unit, count } = granularity;
  return unit === "hour" || (unit === "day" && count === 1);
};

export const timeBarExpandRange = (timestamp, granularity) => {
  const { unit, count } = granularity;

  const start = moment.utc(timestamp).startOf("day");
  const end = isLessThanADay(granularity)
    ? moment.utc(start)
    : moment
        .utc(start)
        .add(count, unit)
        .subtract(1, "day");

  return { start, end };
};

export const formatTimeCrosshairTitle = values => ({
  title: "Date",
  value: moment.utc(values[0].x).format("ddd, MMM Do YY, HH:00")
});

export const formatAccountsCrosshairTitle = values => ({
  title: "Account",
  value: values[0].y.split("|")[1]
});



// WEBPACK FOOTER //
// ./src/helpers/charts.js